export const isEnumValue = <T extends object>(enumObj: T, value: any): value is T[keyof T] =>
  Object.values(enumObj).includes(value);
